import { MunicipalitySearch as component } from './component'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { AppState } from 'stores/index'
import { mapActiveMunicipality } from 'components/map/actions'
import { createSelector } from 'reselect'

const valuesByMunicipalitySelector = (state: AppState) =>
  state.valuesByMunicipality
const municipalityListSelector = createSelector(
  valuesByMunicipalitySelector,
  map => Array.from(map.values())
)

function mapStateToProps(state: AppState) {
  return {
    municipalityList: municipalityListSelector(state)
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onSelection: (id: string) => {
      dispatch(mapActiveMunicipality(id))
    }
  }
}

export const MunicipalitySearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(component)
